var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-mobile-search-button t-heading-6",attrs:{"tabindex":_vm.tabindexStart},on:{"click":_vm.showSearch}},[_vm._v("\n  Search\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }